import Popup from "reactjs-popup";
import { useUpdateProfile } from "../../lib/queries/queriesAndMutations";
import { toast } from "react-toastify";
import Loader from "../../shared/Loader";
import { useState } from "react";
import icons from "../../lib/icons";
import { useQueryClient } from "@tanstack/react-query";

const EmailUpdateModalBtn = ({ userEmail }) => {
  const [email, setEmail] = useState(userEmail);
  const { mutateAsync: updateEmail, isPending } = useUpdateProfile();
  const queryClient = useQueryClient();

  const handleUpdateEmail = async () => {
    try {
      const response = await updateEmail(email);
      if (response.status === 200) {
        queryClient.invalidateQueries({ queryKey: ["getProfile"] });
        toast.success("عملیات موفق");
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <>
      <Popup
        trigger={
          <button className="btn-edit flex items-center gap-1">
            <p>ویرایش </p>
            <img src={icons.edit} alt="" width={16} height={16} />
          </button>
        }
        modal
        nested
      >
        {(close) => (
          <div
            className="modal-wrapper "
            dir="rtl"
          >
            <label htmlFor="">ایمیل</label>
            <input
              defaultValue={userEmail}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-[52px] px-4 outline-none rounded-v-md w-full border-2 border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
            />
            <div className="flex mr-auto gap-1 mt-8">
              <button
                onClick={close}
                className="secondary-btn"
                disabled={isPending}
              >
                انصراف
              </button>
              <button
                onClick={handleUpdateEmail}
                className="primary-btn"
                disabled={isPending}
              >
                {isPending ? (
                  <div className="w-8 h-8 mx-auto">
                    <Loader />
                  </div>
                ) : (
                  "ویرایش"
                )}
              </button>
            </div>
          </div>
        )}
      </Popup>
    </>
  );
};

export default EmailUpdateModalBtn;
